import { useAccordion } from '../../../customHook.js/useAccordion'
import useScrollAnimation from '../../../customHook.js/useScrollAnimation'

import RenderContent from '../../../helpers/RenderContent'
import { highlightText } from '../../../helpers/helperFunctions'
import { health1 } from '../../../const/contentData'
import openingParagraph from '../../../const/openingParagraph'
import modelRTL from '../../../const/modelRTL'
import sport from '../../../images/sport.jpg'

import iHealth from '../../../images/health.svg'
import classes from '../content.module.css'

function Health({ searchTerm }) {
  const moduleName = 'health'

  const { selectedRow, highlightedText, changeSelectedRow } = useAccordion(
    moduleName,
    searchTerm,
    0
  )
  const getToContainer = useScrollAnimation(moduleName)

  return (
    <div
      className={`${classes.main_container} ${
        !modelRTL[moduleName] && 'row_reverse'
      }`}
      id={moduleName}
    >
      <div
        className={`${classes.text_area} ${
          modelRTL[moduleName] ? classes.hidden_left : classes.hidden_right
        } ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <p className="fw_500">
          {highlightText(openingParagraph.health[0], highlightedText)}
        </p>
        <p className="fw_700">
          {highlightText(openingParagraph.health[1], highlightedText)}
        </p>
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <img className={classes.section_img} src={iHealth} alt="iHealth" />
          </div>
          <div>
            {health1.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title}  ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`${classes.main_img_container} ${
          modelRTL[moduleName] ? classes.hidden_right : classes.hidden_left
        }  ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <img src={sport} alt="sport" />
        <div>
          <h2>זה יופי</h2>
          <h2>להיות בריא</h2>
        </div>
      </div>
    </div>
  )
}

export default Health
